import { Fragment, render } from 'preact'
import register from 'preact-custom-element'
import { useState } from 'preact/hooks'
import QuantityInput from 'snippets/quantity-input/quantity-input'

function QuantityItem () {
  const [quantity, setQuantity] = useState(1)

  return (
    <Fragment>
      <div title="Quantity input" class="w-[122px]">
        <QuantityInput inputKey={quantity} quantity={quantity} min="0" max='10' setQuantity={setQuantity} />
      </div>
    </Fragment>
  )
}

export default QuantityItem

register(QuantityItem, 'quantity-item')
